export const alertSnackbarStyles = {
  bottom: { xs: 90, md: 30 },
  width: { xs: "90%", md: 600 },
};

export const alertSnackbarAlertStyles = {
  width: "100%",
};
